import SiteHeader from "@/components/SiteHeader";
import Footer from "@/components/Footer";

const PageShell = ({ children }) => (
  <>
    <SiteHeader />
    <main className="pt-[64px]">{children}</main>
    <Footer />
  </>
);

export default PageShell;
